export const CLASSTING_URL = process.env.REACT_APP_CLASSTING_URL
